import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  FormattedPlural,
  FormattedMessage,
  injectIntl, FormattedHTMLMessage,
} from 'react-intl'
import { FormattedDate, FormattedTime } from 'components/intl'
import { ImageGallery } from 'containers/misc'
import moment from 'moment'
import styles from './activity-logs-list.styl'
import { Button } from '../../../misc'
import { AddMessageModal } from '../../../modals'
import { connect } from 'react-redux'
import { modal } from '../../../../redux/modules/app'
import uuid from 'uuid'
import { get } from 'lodash'
import { PROGRESS_STATES } from '../../../../constants/enums'

@injectIntl
@connect(null, { modal })
class ActivityLogsList extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    logs: PropTypes.array,
    // limit: PropTypes.number.isRequired,
    intl: PropTypes.object.isRequired,
    onLogClick: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    award: PropTypes.object.isRequired,
    isMessagingEnabled: PropTypes.bool.isRequired,
    activityState: PropTypes.string.isRequired
  }

  static defaultProps = {
    logs: [],
    // limit: 10
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      activityLog: {},
      formLocked: false
    }
  }

  handleOpenAddMessageDialog = log => {
    this.setState(
        {
          activityLog: log,
          formLocked: false
        },
        () => {
          this.props.modal('add-message-modal')
        }
    )
  }

  render() {
    const { logs, onLogClick, disabled, intl, award, isMessagingEnabled, activityState } = this.props

    const forbiddenActivityStates = [
      PROGRESS_STATES.activityApproval.id,
      PROGRESS_STATES.activityComplete.id,
      PROGRESS_STATES.activityOfficeSignoff.id,
      PROGRESS_STATES.activityCeremony.id,
      PROGRESS_STATES.activityInactive.id,
      PROGRESS_STATES.activityDeleted.id,
    ]

    const canAddPraise = !forbiddenActivityStates.includes(get(activityState, 'value'))

    return (
      <div>
        {logs.length > 0 && (
          <ul className={styles.logs}>
            {logs.map((log, index) => {
              const time = moment.duration(log.duration, 'seconds')
              const hours = Math.floor(time.asHours())
              const mins = Math.floor(time.asMinutes()) - hours * 60
              const isDeleted = log && log.deleted === true

              return (
                <li
                  key={`${log.id}-${index}`}
                  className={[styles.log, isDeleted && styles.deleted].join(' ')}
                >
                  <div>
                  <div className={styles.link} onClick={() => onLogClick(log.id, disabled)}>
                    <div className={styles.header}>
                      <div className={styles.time}>
                        {log.date && <FormattedDate value={log.date} spaceAfter />}{' '}
                        <span className={styles.duration}>
                          {hours}{' '}
                          <FormattedPlural
                            value={hours}
                            one={intl.formatMessage({
                              id: 'logs.hour',
                              defaultMessage: 'hour',
                            })}
                            other={intl.formatMessage({
                              id: 'logs.hours',
                              defaultMessage: 'hours',
                            })}
                          />{' '}
                          &nbsp;
                          {mins}{' '}
                          <FormattedPlural
                            value={mins}
                            one={intl.formatMessage({
                              id: 'logs.minute',
                              defaultMessage: 'minute',
                            })}
                            other={intl.formatMessage({
                              id: 'logs.minutes',
                              defaultMessage: 'minutes',
                            })}
                          />
                        </span>
                        {isDeleted && (
                          <span className={styles.deletedText}>
                            <FormattedMessage defaultMessage="Deleted" id="states.deleted" />
                          </span>
                        )}
                      </div>
                      <div className={styles.created}>
                        {log.createdAt && (
                          <div>
                            <FormattedMessage id="label.created_at" defaultMessage="Created at" />
                            : <FormattedDate timeZone="utc" value={log.createdAt} spaceAfter />{' '}
                            <FormattedTime timeZone="utc" value={log.createdAt} />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.footer}>
                      <p className={styles.description}>{log.description}</p>
                    </div>
                  </div>
                  <ImageGallery urls={log.fileUrls || []} className={styles.image} />
                    {isMessagingEnabled && <div className={get(log,'praises') && get(log,'praises').length > 0 ? styles.praise_wrapper : styles.praise_wrapper_empty}>
                    {get(log,'praises') && get(log,'praises').length > 0 && get(log,'praises').map((praise) => {

                      return (
                          <div className={styles.praise_answer}>
                            <div className={styles.praise_answer_text}>
                            <FormattedHTMLMessage
                              id="praise.content"
                              defaultMessage={get(praise,'translationMessage')}
                            />
                            </div>
                            <div className={styles.praise_author}>
                             <span>{get(praise,'author.firstName')} {get(praise,'author.lastName')}</span><br />
                              <span>{get(praise,'createdAt') && <FormattedDate timeZone="utc" value={get(praise,'createdAt')} spaceAfter />}{' '}</span>
                            </div>
                          </div>)
                    })}

                 { canAddPraise && <div className={styles.praise_button_block}>
                  <Button
                      type="button"
                      intlKey="button.praise"
                      onClick={() => this.handleOpenAddMessageDialog(log)}
                  >
                    Comment
                  </Button>
                  </div>}


                    </div>}
                  </div>
                </li>
              )
            })}
          </ul>
        )}
        {logs.length === 0 && <FormattedMessage id="logs.no_logs" defaultMessage="No logs" />}
        <AddMessageModal
            modalId="add-message-modal"
            awardId={award.id}
            activityLog={this.state.activityLog}
            formLocked={this.state.formLocked}
            onLockForm={locked => this.setState({ formLocked: locked })}
        />
      </div>
    )
  }
}

export default ActivityLogsList
